import * as yup from 'yup'
import yupValidation from '../../../lib/yupValidation'
import { getOnlyDigits } from '../../../utils/Utils'

const form = yup.object().shape({
  numero: yup
    .string()
    .test(
      'teste-number',
      'Número deve ser maior que 0 e menor que 100.',
      value => {
        if (value) {
          const onlyDigits =
            typeof value === 'string' ? Number(getOnlyDigits(value)) : value

          if (onlyDigits > 0 && onlyDigits < 100) {
            return true
          }
        }

        return false
      }
    )
    .required('Obrigatório'),
  descricao: yup
    .string()
    .trim()
    .required('Obrigatório')
})

export const validateForm = yupValidation(form)
